import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import context from '../core/context'
import SearchSkills from './search-skills'
import CategoryLoadMore from './category-load-more'
import FilterButton from './filter-button'

function FilterStep({ labels, skills, roles, experience, dark }) {
  const { filters, setStep } = useContext(context)
  const selectedSkills = skills.filter(skill => filters.skill.includes(skill.term_id))
  const selectedRoles = roles.filter(role => filters.role.includes(role.term_id))
  const selectedExperience = experience.filter(exp => filters.experience.includes(exp.term_id))

  const buttonEnable = selectedSkills.length || selectedRoles.length || selectedExperience.length

  function nextStep() {
    setStep(1)
    document.dispatchEvent(new CustomEvent('step-updated'))
  }

  return (
    <div className="developer-search__view">
      <div className="developer-search__header">
        {labels.headline && (
          <h2
            className={`headline headline--hero ${dark ? 'text-white' : 'text-deep-blue'}`}
            dangerouslySetInnerHTML={{ __html: labels.headline }}
          />
        )}
        <div className="developer-search__view__header">
          {labels.step_1.headline && (
            <h3 className={`headline headline--md ${dark ? 'text-white' : 'text-deep-blue'}`}>
              {labels.step_1.headline}
            </h3>
          )}
          <SearchSkills skills={skills} roles={roles} experience={experience} />
        </div>
      </div>
      <div className="developer-search__selection__wrapper">
        <div className="developer-search__selection">
          {selectedSkills.map(skill => (
            <FilterButton term={skill} key={skill.term_id} dark={dark} />
          ))}
          {selectedRoles.map(role => (
            <FilterButton term={role} key={role.term_id} />
          ))}
          {selectedExperience.map(exp => (
            <FilterButton term={exp} key={exp.term_id} />
          ))}
        </div>
        <button
          className={`btn ${dark ? 'btn--white text-deep-blue' : 'btn--deep-blue text-white'}`}
          type="button"
          onClick={nextStep}
          disabled={!buttonEnable}
        >
          Next
        </button>
      </div>
      {skills.length > 0 && (
        <div className="developer-search__category">
          <h3 className={`headline headline--xs ${dark ? 'text-white' : 'text-deep-blue'}`}>
            Based on skills
          </h3>
          <CategoryLoadMore terms={skills} />
        </div>
      )}
      {roles.length > 0 && (
        <div className="developer-search__category">
          <h3 className={`headline headline--xs ${dark ? 'text-white' : 'text-deep-blue'}`}>
            Based on role
          </h3>
          <CategoryLoadMore terms={roles} />
        </div>
      )}
      {experience.length > 0 && (
        <div className="developer-search__category">
          <h3 className={`headline headline--xs ${dark ? 'text-white' : 'text-deep-blue'}`}>
            Based on career trajectory
          </h3>
          <CategoryLoadMore terms={experience} />
        </div>
      )}
    </div>
  )
}

FilterStep.propTypes = {
  labels: PropTypes.object.isRequired,
  skills: PropTypes.array.isRequired,
  roles: PropTypes.array.isRequired,
  experience: PropTypes.array.isRequired,
  dark: PropTypes.bool.isRequired,
}

export default FilterStep
